import React from 'react';
import './style.scss';
import clsx from 'clsx';
import Button from '../../../Shared/components/controls/Button';
import icons from '../../../../common/Icons';
import { Image, Text } from '@sitecore-jss/sitecore-jss-react';

const CardsListStickyCompareBar = ({
  cards,
  unselectAll,
  unselectCard,
  cardsAmount = 3,
  onCompare,
}) => (
  <div
    className={clsx('cards-list-compare-bar-wrapper', cards?.length > 0 && 'clcb-wrapper-visible')}
  >
    <div className="cards-list-compare-bar content">
      <Header
        selected={cards.length}
        total={cardsAmount}
        unselectAll={unselectAll}
        handleCompareClick={onCompare}
      />
      <div className="cl-cb-cards-grid">
        {[...Array(cardsAmount)].map((_, index) => {
          if (cards[index]) {
            return (
              <Card
                data={cards[index]}
                key={index}
                removeCard={() => unselectCard(cards[index].id)}
              />
            );
          }
          return <Placeholder key={index} index={index + 1} />;
        })}
      </div>
    </div>
  </div>
);

const Header = ({ selected, total, unselectAll, handleCompareClick }) => (
  <div className="cl-cb-header">
    <div className="cl-cb-header-title">
      You have selected {selected} out of {total} cards
    </div>
    <div className="cl-cb-header-buttons">
      <Button
        variant="text"
        color="secondary"
        onClick={unselectAll}
        className="cl-cb-header-clear-button"
      >
        <div>Clear Selection</div>
        <img src={icons.crossCircle} />
      </Button>
      <Button
        disabled={selected < 2}
        variant="contained"
        color="secondary"
        onClick={handleCompareClick}
      >
        <span className="cl-cb-header-button-pc">Compare Cards</span>
        <span className="cl-cb-header-button-mobile">Compare</span>
      </Button>
    </div>
  </div>
);

const Card = ({ data, removeCard }) => (
  <div className="cl-cb-cards-grid-item cl-cb-card">
    <div className="cl-cb-card-image-wrapper">
      <Image field={data.image} className="cl-cb-card-image" />
    </div>
    <div className="cl-cb-card-title">
      <Text field={data.title} />
    </div>
    <button className="cl-cb-card-delete" onClick={removeCard}>
      <img src={icons.crossCircle} />
    </button>
  </div>
);

const Placeholder = ({ index }) => (
  <div className="cl-cb-cards-grid-item cl-cb-placeholder">
    <div className="cl-cb-placeholder-index">{index}</div>
  </div>
);

export default CardsListStickyCompareBar;
